 var swiper = new Swiper(".popular-products", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    375: {
      slidesPerView: 1.1,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 2.2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2.3,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 2.3,
      spaceBetween: 32,
    },
  },
});